<template>
<v-card class="d-md-none">

  <div class="video-responsive">
    <iframe :src="videoIframe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" autoplay></iframe>
  </div>

</v-card>
</template>
<script>
export default {
  props: ['project'],
  name: "",
  data: () => ({
    show_video_player: false,
    show_more: false
  }),
  computed: {
    sponsor_options() {
      return [5, 15, 25]
    },
    videoIframe() {
      return this.$helpers.iframeFromUrl(this.project.url)
    }
  }
}
</script>
<style lang="scss" scoped>
.video-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
}
.video-responsive iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
}
</style>
